var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5194 83.6441C27.3356 82.3809 26 80.1309 26 77.715V64.2245C26 63.7081 26.1462 63.2102 26.4192 62.7676C27.2674 61.3844 29.1489 60.9141 30.6113 61.7256L62.8024 79.4762C64.684 80.5182 65.8441 82.4177 65.8441 84.4833V98.4625C65.8441 99.0987 65.6589 99.735 65.3079 100.279C64.2453 101.92 61.9835 102.437 60.2482 101.432L29.5194 83.6441ZM77.5039 58.0279C79.3854 59.0699 80.5455 60.9694 80.5455 63.035V91.3991C80.5455 92.2382 80.0678 93.0128 79.2977 93.4185L72.2492 97.1715C72.1614 97.2176 72.0639 97.2545 71.9664 97.2822V81.5325C71.9664 79.4946 70.8356 77.6043 68.9833 76.5531L40.7112 60.5545V42.7762C40.7112 42.2598 40.8574 41.7619 41.1304 41.3192C41.9786 39.9361 43.8601 39.4658 45.3225 40.2773L77.5039 58.0279ZM91.5911 37.0775C93.4824 38.1103 94.6426 40.0283 94.6426 42.0938V83.5243C94.6426 84.3726 94.1454 85.1564 93.3557 85.5621L86.6777 88.9739V60.1303C86.6777 58.0924 85.5468 56.2113 83.7042 55.1601L54.8082 38.765V21.8996C54.8082 21.3832 54.9545 20.8852 55.2177 20.4426C56.0659 19.0595 57.9474 18.5892 59.4098 19.3914L91.5911 37.0775Z",
    fill: "#00D395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompound);
export default __webpack_public_path__ + "static/media/Compound.4b04f06eb651eb9d579b56737936d248.svg";
export { ForwardRef as ReactComponent };